import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { AisProduct } from "src/app/shared/enums/AisProducts";

export const aisProductParamsGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const aisProduct = route.paramMap.get("aisProduct");
  const validValues = Object.values(AisProduct);

  if (!aisProduct || !validValues.includes(aisProduct as AisProduct)) {
    return router.navigate(["/change-request/new/ais-product"]);
  }

  return true;
};
